/* 
 * 
 * 
 * 
 * 								L I B   N A M E S
 * 
 * 
 * 
 */

export const lib_names = {
	aspectRatios: {
		dish_image: { 'ar': 1 / 1, 'w': 1, 'h': 1 },
	},
	localStorage: {
		user___changelog_view: '1ce31efd6d4767550addcf4fbd26dc265c8bb085',
		user___cookies_accepted: '1e9381a3d73bae2652354a3068c3f2604ecacd3e',
		user___language: '1d9276431fa569a2d17f51a9a797491ac60cede4',
		user___logintoken: '1435ea36bde2346fb69a6bc57c4f7699e4d54bcf',
	},
	lodash: {
		debounce_delay: 500,
	},
	mongo: {
		query_limit: 15,
		query_limit_extended: 500,
		query_limit_few: 3,
		query_limit_single: 1,
	},
}